import * as React from 'react'
import styles from './index.module.css'

export type Props = {
  id?: string
  section: Record<string, any>
}

const ExplorerSection = (props: Props): React.ReactElement<'div'> => {
  const { id, section } = props
  return (
    <div id={id} className={styles.explorerSection}>
      {section.name}
    </div>
  )
}

export default ExplorerSection
